<template>

  <v-container fluid>
  
    <!-- 업로드 프로그레스 -->
    <comloading :isVisible="progress_dialog" :progress="progress_value" />

    <!-- 이미지 크롭 팝업 -->
    <v-row>
      <v-dialog persistent scrollable overlay-color="#00000040" v-model="crop_dialog" @keydown.esc="cancel_crop" max-width="500px">
        <v-card class="dialog_round pa-10">
          <v-row dense align="center">
            <v-col cols="11" md="11" sm="11" xs="11">
              <span class="dialog_title">{{$t("common_crop")}}</span>
            </v-col>
            <v-col cols="1" md="1" sm="1" xs="1">
              <v-btn class="dialog_close_btn mr-1" outlined rounded fab x-small @click="cancel_crop"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>

          <v-row dense justify="center">
            <v-col cols="12" md="12" sm="12" xs="12">
              <div style="background:#4e6ef7;height:2px;" />
            </v-col>
          </v-row>

          <v-card-text>
            <div style="width:100%;height:500px;">

              <vue-cropper
                  ref="cropper_land"
                  :key="option.autoCropWidth + '_' + option.autoCropHeight"
                  :src="imgSrc"
                  :aspect-ratio="option.autoCropWidth/option.autoCropHeight"
                  />

            </div>
            
          </v-card-text>
          <v-card-actions>
            <v-row justify="center">
            <v-btn class="dialog_cancel_btn mr-5" rounded large @click="cancel_crop">{{$t("common_cancel")}}</v-btn>
            <v-btn class="dialog_btn" rounded large @click="cropimg">{{$t("common_ok")}}</v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>    

    <v-row justify="center" dense>
      <v-col cols="12" md="10">
      </v-col>
    </v-row>
    
    <v-row justify="center" dense>
      <v-col cols="12" md="10">

        <v-row dense>
          <v-col cols="3">
            <label class="menunamestyle">{{ `${this.DEVICE_NAME}/${this.DEVICE_DESC}` }}</label>
          </v-col>
          <v-spacer/>
          <deviceloaddialog :eventname="SEARCH_DEVICE_NAME" :comidx="COMIDX" @callback="devicesearchcb"/>
          <v-btn  elevation="0" color="primary" class="ml-1" width="100" @click="save">{{$t('pagesetinfo_col36')}}</v-btn>
        </v-row>
  
        <v-row justify="center" align="center" dense>
          <v-col cols="12" md="12">
            <div class="input_title w-100">{{$t('kiosksetting_msg1')}}</div>
          </v-col>
        </v-row>

        <div class="d-flex flex-row align-center">
          <label class="input_title" style="width:200px !important">{{$t('kiosksetting_msg11')}}</label>
          <v-checkbox dense v-model="editedItem.USE_PRINT" class="ml-5"/>

          <label class="input_title ml-2" style="width:200px !important" v-if="editedItem.USE_PRINT">{{$t('kiosksetting_msg2')}}</label>
          <v-checkbox v-if="editedItem.USE_PRINT" dense v-model="editedItem.USE_PASSWORD" class="ml-5"/>

          <label class="input_title ml-2" style="width:200px !important" v-if="editedItem.USE_PRINT">{{$t('kiosksetting_msg3')}}</label>
          <v-checkbox v-if="editedItem.USE_PRINT" dense v-model="editedItem.USE_GROUPPRINT" class="ml-5"/>

          <label class="input_title ml-2" style="width:200px !important" v-if="editedItem.USE_PRINT">{{$t('kiosksetting_msg4')}}</label>
          <v-checkbox v-if="editedItem.USE_PRINT" dense v-model="editedItem.USE_BEFOREPRINT" class="ml-5"/>

          <label class="input_title ml-2" style="width:200px !important" v-if="editedItem.USE_PRINT">{{$t('kiosksetting_msg5')}}</label>
          <v-checkbox v-if="editedItem.USE_PRINT" dense v-model="editedItem.USE_DUPLEPRINT" class="ml-5"/>

        </div>

        <div class="d-flex flex-row mt-2 align-center">
          <label class="input_title" style="width:200px !important">{{$t('kiosksetting_msg6')}}</label>
          <v-select 
            v-model="editedItem.SELECT_LAN" :items="LANTYPELIST" :placeholder="$t('kiosksetting_msg6')" 
            item-text="name" item-value="value" outlined dense 
            hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
            bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
            />
        </div>

        <div class="d-flex flex-row mt-5 align-center">

          <label class="input_title" style="width:200px !important">{{$t('kiosksetting_msg7')}}</label>
          <v-select 
            v-model="editedItem.PRINT_WAIT" :items="TIMETYPELIST" :placeholder="$t('kiosksetting_msg7')" 
            item-text="name" item-value="value" outlined dense 
            hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
            bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
            />

          <label class="input_title ml-2" style="width:200px !important">{{$t('kiosksetting_msg8')}}</label>
          <v-select 
            v-model="editedItem.BG_WAIT" :items="TIMETYPELIST" :placeholder="$t('kiosksetting_msg8')" 
            item-text="name" item-value="value" outlined dense 
            hide-details elevation="0" style="max-width:200px !important" class="input_select ml-2"
            bg-color="#ffffff" base-color="#d7d7d7" color="#81d3f8" 
            />

        </div>


        <div class="d-flex flex-row align-center">
          <label class="input_title" style="width:200px !important">{{$t('kiosksetting_msg9')}}</label>
          <v-checkbox dense v-model="editedItem.USE_BOTTOM" class="ml-5"/>
        </div>

        <div class="d-flex flex-row" v-if="editedItem.USE_BOTTOM">
          <label class="input_title" style="width:200px !important">{{$t('kiosksetting_msg10')}}</label>
          <input
            v-model="editedItem.BOTTOM_MSG" 
            class="input_input" style="width:80%" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
            :placeholder="$t('kiosksetting_msg10')"
            />
        </div>
        
        <v-row justify="center" align="center" dense class="mt-5">
          <v-col cols="12" md="12">
            <div class="input_title w-100">{{$t('kiosksetting_msg12')}}</div>
          </v-col>
        </v-row>
        <div class="d-flex flex-row mt-2">
          <label class="input_title" style="width:200px !important">{{$t('kiosksetting_msg13')}}</label>
          <input
            v-model="editedItem.INFO_TITLE" 
            class="input_input" style="width:80%" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
            :placeholder="$t('kiosksetting_msg13')"
            />
        </div>
        <div class="d-flex flex-row mt-2">
          <label class="input_title" style="width:200px !important">{{$t('kiosksetting_msg14')}}</label>
          <textarea
            v-model="editedItem.INFO_DESC" 
            outlined rows="2" class="input_area" style="white-space:pre-line;width:80%;"
            :placeholder="$t('kiosksetting_msg14')"
            dense single-line hide-details
            />          
        </div>
        <div class="d-flex flex-row mt-2">
          <label class="input_title" style="width:200px !important">{{$t('kiosksetting_msg15')}}</label>
          <input
            v-model="editedItem.INFO_BTN1" 
            class="input_input" style="width:80%" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
            :placeholder="$t('kiosksetting_msg15')" 
            />
        </div>
        <!-- 
        <div class="d-flex flex-row mt-2">
          <label class="input_title" style="width:200px !important">{{$t('kiosksetting_msg16')}}</label>
          <input
            v-model="editedItem.INFO_BTN2" 
            class="input_input" style="width:80%" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
            :placeholder="$t('kiosksetting_msg16')" 
            />
        </div>
        -->

        <v-row justify="center" align="center" dense class="mt-5">
          <v-col cols="12" md="12">
            <div class="input_title w-100">{{$t('kiosksetting_msg17')}}</div>
          </v-col>
        </v-row>
        
        <div class="d-flex flex-row mt-2">
          <label class="input_title" style="width:200px !important">{{$t('kiosksetting_msg31')}}</label>
          <input
            v-model="editedItem.TEL_TITLE" 
            class="input_input" style="width:80%" :class="$vuetify.breakpoint.smAndDown ? 'input_mobile' : ''"
            :placeholder="$t('kiosksetting_msg31')" 
            />
        </div>
        <div class="d-flex flex-row mt-2">
          <label class="input_title" style="width:200px !important">{{$t('kiosksetting_msg32')}}</label>
          <textarea
            v-model="editedItem.TEL_DESC" 
            outlined rows="2" class="input_area" style="white-space:pre-line;width:80%;"
            :placeholder="$t('kiosksetting_msg32')"
            dense single-line hide-details
            /> 
        </div>

        <v-row justify="center" align="center" dense class="mt-5">
          <v-col cols="12" md="12">
            <div class="input_title w-100">{{$t('kiosksetting_msg25')}}</div>
          </v-col>
        </v-row>
        <div class="d-flex flex-row align-center">
          <label class="input_title" style="width:200px !important">{{$t('kiosksetting_msg26')}}</label>
          <v-checkbox dense v-model="editedItem.USE_GROUPPOPUP" class="ml-5"/>
        </div>
        <div class="d-flex flex-row" v-if="editedItem.USE_GROUPPOPUP">
          <v-textarea
            v-model="editedItem.GROUP_MSG" 
            outlined rows="3" class="mt-1"
            style="white-space:pre-line;width:100%"
            :placeholder="$t('kiosksetting_msg27')"
            dense single-line hide-details maxlength="132"
            />          
        </div>


      </v-col>
    </v-row>

    <v-row style="height:100px"/>

    </v-container>
  </template>
  
  <script>
import VueCropper from 'vue-cropperjs'; //이미지 크롭
import 'cropperjs/dist/cropper.css';
//import { VueCropper } from 'vue-cropper'; //교체용 크롭 라이브러리
import cmvalidation from '../assets/js/cmvalidation.js'

  export default {
      components:{
        VueCropper
      },
  
      data: () => ({
        
        DEVICE_IDX: null,
        COMIDX: null,
        DEVICE_NAME: "",
        DEVICE_DESC: "",
        
        SEARCH_DEVICE_NAME:"",
        SEARCH_DEVICE_IDX: null,

        LANTYPELIST: [
            {name:'KOREA',       value:0}
          , {name:'ENGLISH',     value:1}
        ],

        TIMETYPELIST:[
            {name:'1s',     value:1000}
          , {name:'2s',     value:2000}
          , {name:'3s',     value:3000}
          , {name:'4s',     value:4000}
          , {name:'5s',     value:5000}
          , {name:'6s',     value:6000}
          , {name:'7s',     value:7000}
          , {name:'8s',     value:8000}
          , {name:'9s',     value:9000}
          , {name:'10s',    value:10000}
          , {name:'11s',    value:11000}
          , {name:'12s',    value:12000}
          , {name:'13s',    value:13000}
          , {name:'14s',    value:14000}
          , {name:'15s',    value:15000}
          , {name:'16s',    value:16000}
          , {name:'17s',    value:17000}
          , {name:'18s',    value:18000}
          , {name:'19s',    value:19000}
          , {name:'20s',    value:20000}
          , {name:'21s',    value:21000}
          , {name:'22s',    value:22000}
          , {name:'23s',    value:23000}
          , {name:'24s',    value:24000}
          , {name:'25s',    value:25000}
          , {name:'26s',    value:26000}
          , {name:'27s',    value:27000}
          , {name:'28s',    value:28000}
          , {name:'29s',    value:29000}
          , {name:'30s',    value:30000}
        ],

        

        progress_dialog : false,    //로딩 표시
        progress_value:0,

        //이미지 크롭
        crop_dialog: false,
        imgSrc:'',
        s3: null,   //aws

        uploadFile : [],
        photo_index: 0,
        previewImg:[],      //이미지 미리보기

        //신규 크롭 파라메터
        option: {
            img: "",
            outputSize: 1,
            outputType: "jpg",
            canMove: true,
            fixed: true,                  //크롭박스 비율 고정
            fixedNumber: [1920, 340],    //크롭박스 비율
            fixedBox: false,      //true면 크롭박스 크기 조절 안됨
            original: false,      //true면 이미지의 원본 크기로 불러와지고 false면 편집창 기준에 맞게 불러와진다.
            canMoveBox: true,
            autoCrop: true,       //true면 자동으로 크롭박스가 표시됨.
            autoCropWidth:100,    //크롭박스의 가로 크기 fixed가 true면 비율대로
            autoCropHeight:100,   //크롭박스의 세로 크기 
            centerBox: true,
            high: false,
            cropData: {},
            enlarge: 1,
            mode: 'contain',
            maxImgSize: 5000,
            limitMinSize: [1000, 300]
        },

        //필수 페이징 파라메터
        totalcnt : 0,       //전체 아이템 개수
        page : 0,
        maxpage : 0,        //전체 페이지 개수
        startpage : 1,      //시작 인덱스
        bottompage : 1,     //하단 페이징 번호의 시작점을 계산하기 위한 변수
        subpage : 1,       //하단 페이징 번호의 종료점을 계산하기 위한 변수
        loading : false,    //로딩 표시

        //CRUD 관련
        dialogTitle: '추가하기',   //다이얼로그 제목
        editedIndex: -1,          //-1이면 신규, -1보다 크면 업데이트
        defaultItem: {
            USE_PASSWORD: 0
          , USE_GROUPPRINT: 0
          , USE_BEFOREPRINT: 0
          , USE_DUPLEPRINT: 0
          , USE_PRINT: 1
          , SELECT_LAN: 0
          , PRINT_WAIT: 8000
          , BG_WAIT: 2000
          , USE_BOTTOM: 1
          , BOTTOM_MSG: "입장권 발급시 화면을 터치해주세요."

          , INFO_TITLE: "환영합니다!"
          , INFO_DESC: "입장권(명찰)을 출력하시려면 QR코드를 인식해주세요."
          , INFO_BTN1: "전화번호 입력"
          //, INFO_BTN2: "전화번호 입력"

          , TEL_TITLE: "전화번호 출력"
          , TEL_DESC: "가입한 전화번호를 입력해주세요"

          , USE_GROUPPOPUP: 1
          , GROUP_MSG: "선택하신 명찰은 출력 후 재출력이 불가능합니다.\n타인의 명찰을 대리 출력하시는 경우, 모든 책임은 출력자 본인에게 있습니다.\n선택한 명찰들을 모두 출력 하시겠습니까?"

        },

        editedItem: {},

        BGTYPELIST: [
            {name:'BASIC',      value:0}
          , {name:'COLOR',       value:1}
          , {name:'IMAGE',     value:2}
        ],

        URLTYPELIST: [
            {name:'BASIC',       value:0}
          , {name:'COLOR',       value:1}
          , {name:'IMAGE',     value:2}
          , {name:'YOUTUBE',  value:3}
        ],

        VIDEOTYPELIST:[
            {name:'YOUTUBE',  value:0}
        ],

        
        grade : 0,
        SEARCH_COM_IDX: null,
        SEARCH_COM_NAME: '',
        SEARCH_EVENT_IDX: null,
        SEARCH_EVENT_NAME: '',

        select_lan : 0


      }),
  
      beforeMount(){
        //로드전에 객체화 (경고 메시지 안나오게)
        this.editedItem = Object.assign({}, this.defaultItem);
      },
  
      mounted(){

        if(this.$session.get("GRADE") < 10){
          this.$alert(this.$t("common_nograde"));
          this.$router.push("Login");
          return;
        }
  
        if(this.$session.exists("ADMIN_IDX")){
          this.initpage();
        }else{
          //키값 없으면 로그인으로
          this.$router.push("Login");
        }
      },
  
      create(){
  
      },


      beforeDestroy(){
        //아이폰의 경우 찌거기 제거
        let indexcnt = navigator.userAgent.toLowerCase().indexOf("mac os x");
        if(indexcnt > -1){
            let elements = document.getElementsByName("imageinputcamera");
            for(var i=0, len=elements.length ; i != len; ++i){
                elements[0].parentNode.removeChild(elements[0]);
            }
        }
      },      
  
      methods: {
  
        showsite(){
          window.open("https://fairpass.co.kr?eventcode="+this.SEARCH_EVENT_IDX, "_blank");
        },

        callback_fontvalue(value, obj){
          let target      = obj;
          target.NAME     = value.NAME;
          target.CODE     = value.CODE;
          target.FONTURL  = value.FONTURL;
          this.$forceUpdate();
        },

        callback_value(value, path, obj){

          const keys = path.split('.');
          let target = obj;

          for (let i = 0; i < keys.length - 1; i++) {
            // 배열 인덱스 처리
            const key = keys[i].match(/^(\w+)\[(\d+)\]$/);
            if (key) {
              const arrayKey = key[1]; // 배열 이름
              const index = parseInt(key[2], 10); // 배열 인덱스

              // 배열이 없으면 생성
              if (!target[arrayKey]) {
                target[arrayKey] = [];
              }

              // 인덱스 위치에 객체가 없으면 생성
              if (!target[arrayKey][index]) {
                target[arrayKey][index] = {};
              }

              target = target[arrayKey][index];
            } else {
              // 일반 객체 처리
              if (!target[keys[i]]) {
                target[keys[i]] = {};
              }
              target = target[keys[i]];
            }
          }        

          // 마지막 키에 값 설정
          const lastKey = keys[keys.length - 1];
          const lastKeyMatch = lastKey.match(/^(\w+)\[(\d+)\]$/);
          if (lastKeyMatch) {
            const arrayKey = lastKeyMatch[1];
            const index = parseInt(lastKeyMatch[2], 10);

            if (!target[arrayKey]) {
              target[arrayKey] = [];
            }

            target[arrayKey][index] = value;
          } else {
            target[lastKey] = value;
          }        
        
          this.$forceUpdate();

        },        

        cancel_crop(){
            this.crop_dialog = false;
        },

        cropimg(){

          this.crop_dialog = false;
          this.$refs.cropper_land.getCroppedCanvas().toBlob((blob) => {
            this.setNestedProperty(this.uploadFile, this.photo_key, blob);
          });
          this.setNestedProperty(this.previewImg, this.photo_key, this.$refs.cropper_land.getCroppedCanvas().toDataURL("image/jpeg"));

        },              

        showImage(obj, path){

          const value = this.getNestedProperty(obj, path);

          if(!value){
              return;
          }
            
          this.$viewerApi({
              options: {
                  zIndex:9999
              },          
              images: [value]
          });

        },  

        fileSelect(key, width, height){

            const changefunction = this.selectfile;
            var input = document.createElement("input");
            input.style = "display:none";
            input.name = "imageinputcamera";
            input.type = "file";
            input.accept = ".jpg,.jpeg,.png"; // 확장자가 xxx, yyy 일때, ".xxx, .yyy"

            /* 크롭사이즈 변경 */
            if(width != null && height != null){
              this.option.autoCropWidth  = width;
              this.option.autoCropHeight = height;
              this.option.aspectRatio = width/height;
              this.option.fixed = true;
            }else{
              this.option.autoCropWidth  = NaN;
              this.option.autoCropHeight = NaN;
              this.option.aspectRatio = NaN;
              this.option.fixed = false;
            }
            this.$forceUpdate();

            let indexcnt = navigator.userAgent.toLowerCase().indexOf("mac os x");
            if(indexcnt > -1){
                //아이폰, 아이패드, 맥
                //input이 실제 돔에 추가되야 사진수정에 따른 onchange가 작동한다.
                document.body.appendChild(input);
                input.onchange = function (event) {
                    document.body.removeChild(input);
                    changefunction(event.target.files[0], key);
                };
            }else{
                input.onchange = function (event) {
                    changefunction(event.target.files[0], key);
                };
            }
            input.click();
        },           

        //아이콘에서 파일 변경시
        selectfile(file, key){

            if(file.size/1024/1024 > 10){
                this.$alert(this.$t('eul_msg101'));
                this.setNestedProperty(this.uploadFile, key, null);
                //this.uploadFile[key] = null;
                return;
            }

            const reader = new FileReader();
            reader.onload = (event)=>{
                this.photo_key    = key;
                this.crop_dialog  = true;
                this.imgSrc       = event.target.result;  //이게 blob데이터
                this.$refs.cropper_land.replace(event.target.result);
            }
            reader.readAsDataURL(file);  //비동기로 파일을 읽어서

        },      

        /**
         * 이미지 업로드
         * @param {number} korname   - 업로드 구분값 (오류시 보여줌)
         * @param {number} imgparam  - 저장할 파일명 이름 
         * @param {number} path      - 이미지 URL을 저장할 객체의 path 
         * @returns {number} 두 숫자의 합
         */        
        async checkimgupload(korname, imgparam, path){
            
            const s3obj     = this.$s3;
            const folder    = this.SEARCH_COM_IDX.toString();         //중간폴더명
            var albumPhotosKey = encodeURIComponent(folder) + "/";    //중간경로명  /게 붙어야 폴더됨.
            // s3에 폴더 생성
            // eslint-disable-next-line no-unused-vars
            await s3obj.putObject({Key: albumPhotosKey}, async (err2, data2) => {
                if(err2) {
                    //앨범생성 오류
                    this.$alert(this.$t('eventinfo_msg16'));
                    return false;
                }
            });   

            //파일이 지정된 경우
            const filevalue = this.getNestedProperty(this.uploadFile, path);
            if(filevalue){
                this.progress_dialog = true;            
                let imgpath;
                let curdate = Date.now().toString();    //무조건 신규 파일명으로 그래야 디자인 갱신됨.
                imgpath  = `${imgparam}_${curdate}.jpg`;
                
                var photoKey = albumPhotosKey + imgpath;                 //최종 경로
                const stored = await s3obj.upload({
                                                        Bucket: "blueorigin-mice-image",
                                                        Key: photoKey,
                                                        Body: filevalue,
                                                        ACL: "public-read"
                                                    }).promise();

                if(stored == null || stored.Location == null){
                    this.progress_dialog = false;
                    this.$fire({ 
                        html:`${this.$t('common_process_fail')} <br> ${korname}`
                    });
                    return false;
                }
                //this.uploadFile[fileindex]  = null;
                this.progress_dialog = false;
                this.setNestedProperty(this.uploadFile, path, null);
                this.setNestedProperty(this.editedItem, path, stored.Location);          //////////////////////

                /*
                const keys = path.split('.');   // 경로를 점(.)으로 분리
                let target = this.editedItem;   // 현재 객체를 탐색
                for (let i = 0; i < keys.length - 1; i++) {
                  if (!target[keys[i]]) {
                    target[keys[i]] = {}; // 키가 없으면 빈 객체 생성
                  }
                  target = target[keys[i]]; // 다음 단계로 이동
                }
                target[keys[keys.length - 1]] = stored.Location;

                //this.editedItem[imgparam]   = stored.Location;
                */
              
                return true;

            }else{
              //파일이 없어도 패스
              this.progress_dialog = false;
              return true;
            }

        },        

        //obj의 path에 값을 저장한다. path는 프로퍼티, 배열인덱스 가능
        setNestedProperty(obj, path, value) {

          const keys = path.split('.'); // 경로를 점(.)으로 분리
          let target = obj;

          for (let i = 0; i < keys.length - 1; i++) {

            // 배열 인덱스 처리
            const arrayMatch = keys[i].match(/^(\w+)\[(\d+)\]$/); // 배열 키 패턴: key[index]
            if (arrayMatch) {
              const arrayKey = arrayMatch[1]; // 배열 이름
              const index = parseInt(arrayMatch[2], 10); // 배열 인덱스

              // 배열이 없으면 생성
              if (!target[arrayKey]) {
                target[arrayKey] = [];
              }

              // 배열의 인덱스에 객체가 없으면 생성
              if (!target[arrayKey][index]) {
                target[arrayKey][index] = {};
              }

              target = target[arrayKey][index]; // 다음 단계로 이동
            } else {
              // 일반 객체 처리
              if (!target[keys[i]]) {
                target[keys[i]] = {}; // 키가 없으면 객체 생성
              }
              target = target[keys[i]]; // 다음 단계로 이동
            }
          }

          // 마지막 키에 값 설정
          const lastKey = keys[keys.length - 1];
          const lastArrayMatch = lastKey.match(/^(\w+)\[(\d+)\]$/);

          if (lastArrayMatch) {
            const arrayKey = lastArrayMatch[1];
            const index = parseInt(lastArrayMatch[2], 10);

            if (!target[arrayKey]) {
              target[arrayKey] = [];
            }

            target[arrayKey][index] = value;
          } else {
            target[lastKey] = value;
          }
        },

        //obj의 특정 path에서 값을 가져온다.
        getNestedProperty(obj, path) {
          
          const keys = path.split('.'); // 경로를 점(.)으로 분리
          let target = obj;

          for (let i = 0; i < keys.length; i++) {
            // 배열 인덱스 처리
            const arrayMatch = keys[i].match(/^(\w+)\[(\d+)\]$/); // 배열 키 패턴: key[index]
            if (arrayMatch) {
              const arrayKey = arrayMatch[1]; // 배열 이름
              const index = parseInt(arrayMatch[2], 10); // 배열 인덱스

              if (!target[arrayKey] || !Array.isArray(target[arrayKey]) || !target[arrayKey][index]) {
                return undefined; // 배열 또는 인덱스가 유효하지 않으면 undefined 반환
              }
              target = target[arrayKey][index];
            } else {
              // 일반 객체 처리
              if (!target[keys[i]]) {
                return undefined; // 키가 없으면 undefined 반환
              }
              target = target[keys[i]];
            }
          }

          return target; // 최종 값을 반환
        },

        //검색조건 업체 설정
        devicesearchcb(val1){
          if(val1 != null || val1 != undefined || val1.ACCNT.length > 0){
            this.SEARCH_DEVICE_NAME = val1.ACCNT;
            this.SEARCH_DEVICE_IDX  = val1.IDX;
            this.loadsetting();
          }else{
            this.SEARCH_DEVICE_NAME = "";
            this.SEARCH_DEVICE_IDX  = null;
          }
        },        

        loadsetting(){

            this.editedItem = {};
            
            if(this.COMIDX == null){
              this.$alert(this.$t('common_select_tcom'));
              return;
            }
            if(this.SEARCH_DEVICE_IDX == undefined || this.SEARCH_DEVICE_IDX == null){
              this.$alert(this.$t("devicedialog_msg1"));
              return;
            }

            this.progress_dialog = true;

            this.$http.post(this.$host+'/api/KioskSetting',{
                  ADMIN_IDX: this.$session.get("ADMIN_IDX")
                , COM_IDX: this.COMIDX
                , DEVICE_IDX: this.SEARCH_DEVICE_IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
            .then((result)=>{
              this.progress_dialog = false;
              if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                    this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                    this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }

                //로드한 경우
                if(result.data.resultData[0].SETTING == null || result.data.resultData[0].SETTING == undefined){
                  this.editedItem = Object.assign({}, this.defaultItem);
                }else{
                  this.editedItem = result.data.resultData[0].SETTING;
                }
  
              }else if(result.data.resultCode == 2){
                //로그인 필요
                this.progress_dialog = false;
                this.$alert(this.$t("common_tokener"));
                this.$session.clear("ADMIN_IDX");
                this.$session.clear("COM_IDX");
                this.$session.clear("ACNT_IDX");
                this.$session.clear("GRADE");
                this.$session.clear("COM_NAME");
                this.$session.clear("ACCESSTOKEN");
                this.$session.clear("REFLASHTOKEN");
                this.$router.push('Login');   //로그인 페이지로 이동
  
              }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error)=>{
              
              this.progress_dialog = false;
              if(error.message == 'Request failed with status code 429')
              {
                this.$alert(this.$t("common_reqer"));
              }else{
                this.$alert(error.message);
              }
            });
  
        },
  
        

        loadpage(){

            this.editedItem = {};
            
            if(this.COMIDX == null){
              this.$alert(this.$t('common_select_tcom'));
              return;
            }
            if(this.DEVICE_IDX == undefined || this.DEVICE_IDX == null){
              this.$alert(this.$t("devicedialog_msg1"));
              return;
            }

            this.progress_dialog = true;

            this.$http.post(this.$host+'/api/KioskSetting',{
                  ADMIN_IDX: this.$session.get("ADMIN_IDX")
                , COM_IDX: this.COMIDX
                , EVENT_IDX: this.EVENT_IDX
                , DEVICE_IDX: this.DEVICE_IDX
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
            .then((result)=>{
              this.progress_dialog = false;
              if(result.data.resultCode == 0){

                //토큰 저장
                if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                    this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                }
                if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                    this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                }
                
                this.DEVICE_NAME = result.data.resultData[0].ACCNT;
                this.DEVICE_DESC = result.data.resultData[0].DESC;

                //로드한 경우
                if(result.data.resultData[0].SETTING == null || result.data.resultData[0].SETTING == undefined){
                  this.editedItem = Object.assign({}, this.defaultItem);
                }else{
                  this.editedItem = result.data.resultData[0].SETTING;
                }

                /*
                this.setNestedProperty(this.previewImg, "PAGELOGO", result.data.resultData[0].PAGELOGO);
                
                if(result.data.resultData[0].TITLE_INFO != null && result.data.resultData[0].TITLE_INFO != undefined){
                  
                  //this.editedItem.TITLE_INFO = JSON.parse(JSON.stringify(result.data.resultData[0].TITLE_INFO));
                  const temp = JSON.parse(JSON.stringify(result.data.resultData[0].TITLE_INFO));
                  this.editedItem.TITLE_INFO = { ...this.defaultItem.TITLE_INFO, ...temp }; //양식이 변경된 경우대비

                  this.setNestedProperty(this.previewImg, "TITLE_INFO.PCBG_URL", this.editedItem.TITLE_INFO.PCBG_URL);
                  this.setNestedProperty(this.previewImg, "TITLE_INFO.MBBG_URL", this.editedItem.TITLE_INFO.MBBG_URL);
                }

                if(result.data.resultData[0].BOTTOM_INFO != null && result.data.resultData[0].BOTTOM_INFO != undefined){
                  this.editedItem.BOTTOM_INFO     = JSON.parse(JSON.stringify(result.data.resultData[0].BOTTOM_INFO));  
                }
                */

                
  
              }else if(result.data.resultCode == 2){
                //로그인 필요
                this.progress_dialog = false;
                this.$alert(this.$t("common_tokener"));
                this.$session.clear("ADMIN_IDX");
                this.$session.clear("COM_IDX");
                this.$session.clear("ACNT_IDX");
                this.$session.clear("GRADE");
                this.$session.clear("COM_NAME");
                this.$session.clear("ACCESSTOKEN");
                this.$session.clear("REFLASHTOKEN");
                this.$router.push('Login');   //로그인 페이지로 이동
  
              }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error)=>{
              
              this.progress_dialog = false;
              if(error.message == 'Request failed with status code 429')
              {
                this.$alert(this.$t("common_reqer"));
              }else{
                this.$alert(error.message);
              }
            });
  
        },
  
        initpage(){

          this.DEVICE_IDX = this.$route.query.device;
          this.COMIDX     = this.$route.query.com;

          //첫페이지 로드
          this.loadpage();

        },      
  
        //검색
        search_run(){
          this.loadpage();
        },




        //추가 저장
        async save () {

          if(this.editedItem.USE_BOTTOM == 1){
            const bottomMsg = cmvalidation.checkValReg(this.editedItem.BOTTOM_MSG, null, -1, -1);
            if(bottomMsg == 1){
              this.$alert(this.$t('kiosksetting_msg18'));
              return;
            }
            if(bottomMsg == 4){
              this.$alert(this.$t('kiosksetting_msg18'));
              return;
            }
          }

          const infotitle = cmvalidation.checkValReg(this.editedItem.INFO_TITLE, null, -1, -1);
          if(infotitle == 1){
            this.$alert(this.$t('kiosksetting_msg19'));
            return;
          }

          const infodesc = cmvalidation.checkValReg(this.editedItem.INFO_DESC, null, -1, -1);
          if(infodesc == 1){
            this.$alert(this.$t('kiosksetting_msg20'));
            return;
          }
          const infobtn1 = cmvalidation.checkValReg(this.editedItem.INFO_BTN1, null, -1, -1);
          if(infobtn1 == 1){
            this.$alert(this.$t('kiosksetting_msg21'));
            return;
          }

          /*
          const infobtn2 = cmvalidation.checkValReg(this.editedItem.INFO_BTN2, null, -1, -1);
          if(infobtn2 == 1){
            this.$alert(this.$t('kiosksetting_msg22'));
            return;
          }
          */

          const tel_title = cmvalidation.checkValReg(this.editedItem.TEL_TITLE, null, -1, -1);
          if(tel_title == 1){
            this.$alert(this.$t('kiosksetting_msg23'));
            return;
          }
          const tel_desc = cmvalidation.checkValReg(this.editedItem.TEL_DESC, null, -1, -1);
          if(tel_desc == 1){
            this.$alert(this.$t('kiosksetting_msg24'));
            return;
          }

          if(this.editedItem.USE_GROUPPOPUP == 1){
            const groupMsg = cmvalidation.checkValReg(this.editedItem.GROUP_MSG, null, -1, -1);
            if(groupMsg == 1){
              this.$alert(this.$t('kiosksetting_msg28'));
              return;
            }
          }

            this.progress_dialog = true;
            this.$http.post(this.$host+'/api/KioskSettingUpdate',{
                  ADMIN_IDX: this.$session.get("ADMIN_IDX")
                , DEVICE_IDX: this.DEVICE_IDX
                , COM_IDX: this.COMIDX
                , SETTING_INFO: JSON.stringify(this.editedItem)
            },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
            .then(async(result)=>{

                this.progress_dialog = false;
                
                if(result.data.resultCode == 0){

                    //토큰 저장
                    if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
                        this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
                    }
                    if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
                        this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
                    }
                    this.$alert(this.$t('common_edit_msg')).then(()=>{
                        //this.loadpage();
                    });

                }else if(result.data.resultCode == 2){
                    //로그인 필요
                    this.$alert(this.$t("common_tokener"));
                    this.$session.clear("ADMIN_IDX");
                    this.$session.clear("COM_IDX");
                    this.$session.clear("ACNT_IDX");
                    this.$session.clear("GRADE");
                    this.$session.clear("COM_NAME");
                    this.$session.clear("ACCESSTOKEN");
                    this.$session.clear("REFLASHTOKEN");
                    this.$router.push('Login');   //로그인 페이지로 이동

                }else{
                    this.$alert(this.$t('deviceadminbg_msg8'));
                }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error)=>{
                this.progress_dialog = false;
                this.$alert(this.$t("common_insert_fail"));
            });

        },              
  
        //검색조건 업체 설정
        eventsearchcb(val1){
          if(val1.NAME.length > 0){
            this.SEARCH_EVENT_NAME = val1.NAME;
            this.SEARCH_EVENT_IDX  = val1.IDX;
            this.$session.set("EVENT_IDX", val1.IDX);
            this.$session.set("EVENT_NAME",val1.NAME);
          }else{
            //일단 업체 선택이 취소되면 리스트를 초기화 시켜야한다.
            
            this.SEARCH_EVENT_NAME = "";
            this.SEARCH_EVENT_IDX  = null;
            this.$session.set("EVENT_IDX", null);
            this.$session.set("EVENT_NAME", "");
          }
          this.editedItem = {};
          this.loadpage();
  
        },      
  
  
        //검색조건 업체 설정
        comsearchcb(val1){
          if(val1.NAME.length > 0){
            this.SEARCH_COM_NAME = val1.NAME;
            this.SEARCH_COM_IDX  = val1.IDX;
          }else{
            this.SEARCH_COM_NAME = '';
            this.SEARCH_COM_IDX  = null;
          }
          this.$session.set("COM_IDX",  this.SEARCH_COM_IDX);
          this.$session.set("COM_NAME", this.SEARCH_COM_NAME);
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          
          this.editedItem = {};
        },
        
        // eslint-disable-next-line no-unused-vars
        comsearchclear(var2){
          this.SEARCH_COM_IDX  = null;
          this.SEARCH_COM_NAME = '';
          this.SEARCH_EVENT_IDX  = null;
          this.SEARCH_EVENT_NAME = '';
          this.$session.set("COM_IDX",  null);
          this.$session.set("COM_NAME", "");
          this.$session.set("EVENT_IDX", null);
          this.$session.set("EVENT_NAME", "");
          
          this.editedItem = {};
  
        },
  
  
        
  
      },
    
  }
  </script>
  
  <!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
  <style scoped>
  
     
  </style>